export function formatPhone(phone) {
  const normalizedPhone = phone.replace(/\D/g, '');

  /* eslint-disable indent */
  return normalizedPhone.length === 10
    ? [...normalizedPhone]
        .flatMap((number, index, array) => {
          if (index === 2 || index === 5) {
            return [`${number}`, '. '];
          }
          if (index !== array.length - 1) {
            return [`${number}`, ' '];
          }
          return `${number}`;
        })
        .join('')
    : phone;
  /* eslint-enable indent */
}
